import { render, staticRenderFns } from "./UnoTemplate.vue?vue&type=template&id=c83b0508&"
import script from "./UnoTemplate.vue?vue&type=script&lang=js&"
export * from "./UnoTemplate.vue?vue&type=script&lang=js&"
import style0 from "./UnoTemplate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports